function IconQuoteStart({fill, stroke}) {
  return (
    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.60775 1.34818C5.00263 1.74945 3.74934 3.00274 3.34806 4.60785L0 18.0001L5.39225 16.652C6.99737 16.2508 8.25065 14.9975 8.65193 13.3924L12 0L6.60775 1.34818Z" fill={fill} />
      <path d="M9.60775 4.34818C8.00263 4.74945 6.74934 6.00274 6.34806 7.60785L3 21.0001L8.39225 19.652C9.99737 19.2508 11.2507 17.9975 11.6519 16.3924L15 3L9.60775 4.34818Z" stroke={stroke} />
    </svg>
  )
}

export default IconQuoteStart